import React, { Component } from "react";
import Views                from "./appointment-widget/views";
import Button               from "./appointment-widget/components/button";
import CloseIcon            from "./appointment-widget/svg/close";
import ReturnIcon           from "./appointment-widget/svg/return";
import MedangelIcon         from "./appointment-widget/svg/medangel";
import ResetIcon            from "./appointment-widget/svg/reset";
import Breadcrumbs          from "./appointment-widget/components/breadcrumbs";
import BreadcrumbsItem      from "./appointment-widget/components/breadcrumbs-item";
import config               from "../config";
import CssTransitionGroup   from "react-addons-css-transition-group";

import "./appointment-widget/widget.css";
import "./appointment-widget/navigation.css";

export default class AppointmentWidget extends Component {
    static get defaultProps() {
        return {
            isVisible: false,
            onCloseClick: null,
            specialization: null,
            clinic: null,
            doctor: null,
            service: null,
            branch: null,
            openWithoutDoctor: null,
        };
    }

    static get propTypes() {
        return {
            isVisible: React.PropTypes.bool,
            onCloseClick: React.PropTypes.func,
            specialization: React.PropTypes.number,
            clinic: React.PropTypes.number,
            doctor: React.PropTypes.string,
            service: React.PropTypes.string,
            branch: React.PropTypes.number,
            openWithoutDoctor: React.PropTypes.number,

        };
    }

    static get contextTypes() {
        return {
            muiTheme: React.PropTypes.object,
        };
    }

    constructor(props) {
        super(props);
        this.state = this.getDefaultState();
        this.bodyStyleOverflow = null;
        this.setBookingIsDone = this.setBookingIsDone.bind(this);
    }

    getDefaultState() {
        /** Get active view depending on properties. */
        const activeViewProps = {};


        let activeView = "StartView";
        activeViewProps.clinic = null;
        activeViewProps.tag = null;
        activeViewProps.openWithoutDoctor = this.props.openWithoutDoctor;
        const hasService = this.props.service !== null;
        const hasClinic = this.props.clinic !== null;
        const hasDoctor = this.props.doctor !== null;
        const hasTag = this.props.tag !== null && this.props.tag !== undefined;

        if (hasClinic){
            activeViewProps.clinic = this.props.clinic;
            if(hasService){
                activeView = "DateView";
                activeViewProps.service = this.props.service;
            }else if(hasDoctor){
                activeView = "ServiceView";
                activeViewProps.doctor = this.props.doctor;
            }else if(hasTag){
                activeView = "ServiceView";
                activeViewProps.tag = this.props.tag;
            }
        }else if(hasService){

            activeView = "BranchView";
            activeViewProps.service = this.props.service;
        }else if(hasDoctor){

            activeView = "BranchView";
            activeViewProps.doctor = this.props.doctor;

        }else if(hasTag){
            activeViewProps.tag = this.props.tag;
            activeView = "ServiceView";
        }



        //
        // if (this.props.service !== null) {
        //         //     if (this.props.openWithoutDoctor !== null){
        //         //         activeView = "DateView";
        //         //         activeViewProps.openWithoutDoctor = this.props.openWithoutDoctor;
        //         //     }else {
        //         //         activeView = "DoctorView";
        //         //     }
        //         //     activeViewProps.service = this.props.service;
        //         // }
        // if (this.props.branch !== null && this.props.clinic === null) {
        //     activeView = "BranchView";
        // }
        //
        // if (this.props.doctor !== null) {
        //     activeView = "ServiceView";
        //     activeViewProps.doctor = this.props.doctor;
        // }
        // if (this.props.tag !== null && this.props.tag !== undefined) {
        //     activeView = "ServiceView";
        //     activeViewProps.tag = this.props.tag;
        // }
        // if (this.props.service !== null) {
        //     activeView = "DoctorView";
        //     activeViewProps.service = this.props.service;
        // }
        // if (this.props.branch !== null) {
        //     if (this.props.clinic !== null) {
        //         activeViewProps.clinic = this.props.clinic;
        //     }else{
        //         activeView = "BranchView";
        //     }
        // }else{
        //     activeViewProps.clinic = 1;
        // }



        return ({
            bookIsDone: false,
            activeView: activeView,
            activeViewProps: activeViewProps,
            animationDirection: "forward",
            isVisible: this.props.isVisible,
            router: [],
        });
    }

    setBookingIsDone(value) {
        this.setState({bookIsDone: value});
    }

    checkIsViewExists(viewName) {
        if (!(viewName in Views)) {
            throw new Error(`View ${this.state.activeView} doesn't exists!`);
        }
    }

    /**
     * Open new view and store previous in router stack.
     * @param  {object} value Configuration of route.
     */
    gotoView(value) {
        const { breadcrumbName, nextView, props } = value;
        const router = this.state.router;

        /**
         * If it is last view or view alredy selected.
         * @param  {string} nextView Next view name.
         */
        if (nextView === null || nextView === this.state.activeView) {
            return;
        }

        this.checkIsViewExists(nextView);
        router.push({
            breadcrumbName: breadcrumbName,
            view: this.state.activeView,
            props: this.state.activeViewProps,
        });

        this.setState({
            activeView: nextView,
            activeViewProps: {
                ...this.state.activeViewProps,
                ...props
            },
            animationDirection: "forward",
            router: router,
        });
    }

    /**
     * Pop from router top router and open view.
     */
    handleReturnButtonClick(reset) {
        let router = this.state.router;
        const route = router.pop();
        let view = "";
        let props = null;
        if (reset) {
            router = [];
            view = "ServiceView";
            props = {clinic: route.props.clinic};
        } else {
            if (route === undefined) {
                return;
            }
            view = route.view;
            props = route.props;
        }
        this.checkIsViewExists(route.view);
        this.setState({
            activeView: view,
            activeViewProps: props,
            router: router,
            animationDirection: "backward",
            bookIsDone: false
        });
    }

    handleCloseButtonClick() {
        if (this.props.onCloseClick !== null) {
            this.props.onCloseClick();
        }

        this.hide();
    }

    show() {
        if (this.state.isVisible === false) {
            const defaultState = this.getDefaultState();
            defaultState.isVisible = true;
            this.setState(defaultState);

            this.bodyStyleOverflow = document.body.style.overflow;
            document.body.style.overflow = "hidden";
        }
    }

    hide() {
        if (this.state.isVisible === true) {
            this.setState({
                isVisible: false,
            });

            document.body.style.overflow = this.bodyStyleOverflow;
        }
    }

    handleBreadcrumbClick(routeIndex) {
        let router = this.state.router;
        if (routeIndex >= 0 && routeIndex < router.length) {
            const route = router[routeIndex];
            router = router.slice(0, routeIndex);

            this.setState({
                activeView: route.view,
                activeViewProps: route.props,
                router: router,
                animationDirection: "backward",
            });
        }
    }

    renderBreadcrumbs() {
        const router = this.state.router;
        const elements = [];
        const startIndex = router.length - 3 > 0 ? router.length - 3 : 0;

        for (let i = startIndex; i < router.length; i++) {
            const route = router[i];
            elements.push(
                <BreadcrumbsItem id={i} key={route.view} onClick={() => this.handleBreadcrumbClick(i)}
                                 disabled={this.state.bookIsDone}>
                    {route.breadcrumbName}
                </BreadcrumbsItem>
            );
        }

        // Push current route position
        const activeViewConstructor = Views[this.state.activeView];
        const breadcrumbName = activeViewConstructor.titleShort !== null ? activeViewConstructor.titleShort : activeViewConstructor.title;

        elements.push(
            <BreadcrumbsItem id={router.length} key={this.state.activeView} isActive={true}>
                {breadcrumbName}
            </BreadcrumbsItem>
        );

        return elements;
    }

    handleOverlayClick() {
        this.hide();
    }

    render() {
        const colors = this.context.muiTheme.palette;

        const viewConstructor = Views[this.state.activeView];
        const view = React.createElement(viewConstructor, {
            key: viewConstructor.title,
            gotoNextView: (value) => this.gotoView(value),
            setBookingIsDone: this.setBookingIsDone,
            ...this.state.activeViewProps,
        });

        const BackIcon = !this.state.bookIsDone ? <ReturnIcon color={colors.alternateTextColor}/> :
            <ResetIcon color={colors.alternateTextColor}/>;

        return (
            <div className="appointment-widget-container">
                <CssTransitionGroup
                    transitionName="appointment-widget-overlay-transition"
                    transitionAppearTimeout={200}
                    transitionEnterTimeout={200}
                    transitionLeaveTimeout={200}>

                    {this.state.isVisible === true ? <div onClick={() => this.handleOverlayClick()} className={"appointment-widget-overlay"}></div> : null}
                </CssTransitionGroup>

                <CssTransitionGroup
                    transitionName="appointment-widget-transition"
                    transitionAppearTimeout={500}
                    transitionEnterTimeout={500}
                    transitionLeaveTimeout={500}>

                    {this.state.isVisible === true ? <div className={"appointment-widget"} style={{
                        color: colors.alternateTextColor,
                        borderColor: colors.primary1color
                    }}>
                        <header className="appointment-widget__navigation appointment-navigation" style={{
                            backgroundColor: colors.primary1color
                        }}>
                            <CssTransitionGroup
                                transitionName="appointment-navigation__button-transition"
                                transitionAppear={true}
                                transitionAppearTimeout={500}
                                transitionEnterTimeout={500}
                                transitionLeaveTimeout={500}>

                                {this.state.router.length > 0 ? <div
                                    key="appointment-navigation__return-button"
                                    className="appointment-navigation__return-button">

                                    <Button onClick={() => this.handleReturnButtonClick(this.state.bookIsDone)}>
                                        {BackIcon}
                                    </Button>
                                </div> : null}
                            </CssTransitionGroup>

                            <div className="appointment-navigation__title">
                                {viewConstructor.title}
                            </div>

                            <div className="appointment-navigation__close-button">
                                <Button onClick={() => this.handleCloseButtonClick()}>
                                    <CloseIcon color={colors.alternateTextColor} />
                                </Button>
                            </div>
                        </header>

                        <nav className="appointment-widget__breadcrumbs" style={{
                            backgroundColor: colors.primary2color
                        }}>
                            <Breadcrumbs>
                                {this.renderBreadcrumbs()}
                            </Breadcrumbs>
                        </nav>

                        <main className="appointment-widget__content" style={{
                            color: colors.textColor,
                            backgroundColor: colors.canvasColor,
                        }}>
                            <CssTransitionGroup
                                className={`appointment-animation-direction--${this.state.animationDirection}`}
                                transitionName="appointment-view"
                                transitionAppearTimeout={500}
                                transitionEnterTimeout={500}
                                transitionLeaveTimeout={500}>

                                {view}
                            </CssTransitionGroup>
                        </main>

                        <footer className="appointment-widget__footer">

                            <MedangelIcon /><span>Работает на платформе <a href={"//medangel.angelsit.ru/"} target={"_blank"}> МедАнгел</a></span>
                        </footer>
                    </div> : null}
                </CssTransitionGroup>
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/AppointmentWidget.js
 **/